export const STATUS_OPTIONS = [
  { value: 'OPEN', label: 'Open' },
  { value: 'IN_PROGRESS', label: 'In Progress' },
  { value: 'ON_HOLD', label: 'On Hold' },
  { value: 'RESOLVED', label: 'Resolved' },
  { value: 'CLOSED', label: 'Closed' },
  { value: 'REOPENED', label: 'Reopened' },
] as const;

export const PRIORITY_OPTIONS = [
  { value: 'URGENT', label: 'Urgent' },
  { value: 'HIGH', label: 'High' },
  { value: 'NORMAL', label: 'Normal' },
  { value: 'LOW', label: 'Low' },
] as const;

export const SLA_STATUS_OPTIONS = [
  { value: 'onTrack', label: 'On Track', color: 'text-emerald-600', bg: 'bg-emerald-50' },
  { value: 'atRisk', label: 'At Risk', color: 'text-amber-600', bg: 'bg-amber-50' },
  { value: 'breached', label: 'Breached', color: 'text-red-600', bg: 'bg-red-50' },
  { value: 'none', label: 'No SLA', color: 'text-slate-500', bg: 'bg-slate-50' },
] as const;
